import React from "react";
import { isChunkError, purgeCachesAndReload, hardRecover } from "@/crashGuard";

/**
 * يلتقط أخطاء العرض (render). خطأ chunk قديم بعد نشر جديد → مسح الكاش
 * وإعادة تحميل محروسة (مرتان/دقيقة كحد أقصى) بدل شاشة بيضاء. أي خطأ آخر →
 * بطاقة خطأ ودّية مع زر إعادة تحميل، ولا ينهار التطبيق كاملاً.
 * يُعاد ضبط الحالة تلقائياً عند تنقل المستخدم (resetKey) حتى لا يعلق
 * المستخدم على بطاقة الخطأ بعد مغادرة الصفحة المعطوبة.
 */
export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, exhausted: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (isChunkError(error)) {
      purgeCachesAndReload().then((ok) => {
        if (!ok) this.setState({ exhausted: true });
      });
    }
  }

  componentDidUpdate(prevProps) {
    // تنقل المستخدم لصفحة أخرى → امسح حالة الخطأ وجرّب العرض من جديد
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null, exhausted: false });
    }
  }

  render() {
    const { error, exhausted } = this.state;
    if (!error) return this.props.children;
    const ar = (localStorage.getItem("rg_lang") || "ar") === "ar";

    // خطأ chunk → إعادة التحميل انطلقت؛ سبينر مؤقت. إن استُنفد الحارس → بطاقة يدوية.
    if (isChunkError(error) && !exhausted) {
      return (
        <div className="min-h-[70vh] flex items-center justify-center" data-testid="chunk-reloading">
          <div className="w-8 h-8 rounded-full border-2 animate-spin"
               style={{ borderColor: "#000000", borderTopColor: "transparent" }} />
        </div>
      );
    }

    return (
      <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 gap-4"
           data-testid="app-error-boundary">
        <div className="text-5xl">🌿</div>
        <div className="text-lg font-bold" style={{ color: "var(--text-main)" }}>
          {ar ? "حدث خطأ غير متوقع" : "Something went wrong"}
        </div>
        <div className="text-sm opacity-60">
          {ar ? "بياناتك محفوظة — اضغط تحديث للمتابعة" : "Your data is safe — tap reload to continue."}
        </div>
        <button onClick={() => hardRecover()}
                className="btn-primary"
                data-testid="app-error-reload-btn">
          {ar ? "تحديث الصفحة" : "Reload"}
        </button>
      </div>
    );
  }
}
